<div class="nfs-left-block">
	<div class="project-name-box" (click)="openProject(clientNf.project.id)">
		{{clientNf.project?.name}}
	</div>
	<div class="email-box">
		{{clientNf.sentTo}}
		<!-- test@test.com -->
	</div>
	<div class="message-box">
		{{clientNf.message}}
	</div>
</div>
<div class="nfs-right-block">
	<div class="send-button-block" *ngIf="!clientNf.resolvedTime">
		<button mat-button class="dismiss-button not-dismissed" (click)="dismissEmail(clientNf)"
			*ngIf="!clientNf.dismissed" [disabled]="dismissLoading">
			<lib-mini-progress-spinner *ngIf="dismissLoading">
			</lib-mini-progress-spinner>
			<div class="dismiss-block" *ngIf="!dismissLoading">Dismiss</div>
		</button>
		<button mat-button class="dismiss-button" *ngIf="clientNf.dismissed" disabled>
			<div *ngIf="!clientNf.dismissedBy?.id" class="dismiss-block">Dismissed</div>
			<div *ngIf="clientNf.dismissedBy?.id" class="dismiss-block">Dismissed
				<i #infoIconHover class="pi pi-info-circle hover-info-icon" (click)="clientNfsOp.toggle($event)"></i>
			</div>
		</button>
	</div>

	<div class="send-button-block" *ngIf="clientNf.resolvedTime && clientNf.sentBy">
		<button mat-button class="sended-message" disabled>
			Sent <i #infoIconHover class="pi pi-info-circle hover-info-icon" (click)="clientNfsOp.toggle($event)"></i>
		</button>
	</div>

	<div class="send-button-block">
		<button mat-button class="send-button" (click)="sendEmail(clientNf)"
			*ngIf="clientNf.sentTo && !clientNf.dismissed">
			<span *ngIf="!clientNf.resolvedTime">View and Send</span>
			<span *ngIf="clientNf.resolvedTime">View</span>
		</button>

		<button mat-button class="send-button" disabled *ngIf="!clientNf.resolvedTime && !clientNf.sentTo">No
			E-Mail</button>

		<button mat-button class="dismiss-button not-dismissed" (click)="deleteNfs(clientNf)" [disabled]="deleteLoading"
			*ngIf="!clientNf.resolvedTime && clientNf.dismissed">
			<lib-mini-progress-spinner *ngIf="deleteLoading">
			</lib-mini-progress-spinner>
			<div class="dismiss-block" *ngIf="!deleteLoading">Delete</div>
		</button>
	</div>
</div>

<p-overlayPanel #clientNfsOp appendTo="body" styleClass="client-nfs-op-block">
	<ng-template pTemplate>
		{{overlayPanelMessage}}
	</ng-template>
</p-overlayPanel>